import { render, staticRenderFns } from "./Selfscanning.vue?vue&type=template&id=79b6700a&scoped=true"
import script from "./Selfscanning.vue?vue&type=script&lang=js"
export * from "./Selfscanning.vue?vue&type=script&lang=js"
import style0 from "./Selfscanning.vue?vue&type=style&index=0&id=79b6700a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b6700a",
  null
  
)

export default component.exports